<main class="px-8 xl:px-0 py-16">

    <section id="sign-up-welcome" class="container mx-auto max-w-screen-xl prose leading-normal">
        <div class="sign-up-welcome__details">
            <div class="sign-up-welcome__copy">
                <div class="callout-circle__blue float-left hidden md:block">
                    <img src="https://assets.syngentaebiz.com/images/media/ssp-YetiLoadoutBucket_cropped.png" alt="Yeti LoadOut Bucket" class="w-[300px] h-[300px] object-center object-scale-down mt-0 mb-0 mr-16">
                </div>
                <p class="text-[22px] sm:text-[24px] md:pt-8 mt-0">Your account has been verified and you're now officially part of the <em>Storen Satisfaction Program!</em></p>
                <p class="text-[22px] sm:text-[24px]">Log in to your <em>Storen Satisfaction Program</em> account.</p>
                <div class="program-login__submit mb-16 md:mb-0">
                    <a id="linkGoToLogin" class="link-btn__blue inline-block mx-auto" data-measurement="SSP - Account Creation Success - Go to Login" (click)="redirectLogin()">Log In</a>
                </div>
            </div>
            <div class="callout-circle__blue block md:hidden">
                <img src="https://assets.syngentaebiz.com/images/media/ssp-YetiLoadoutBucket_cropped.png" alt="Yeti LoadOut Bucket" class="w-[300px] h-[300px] object-center object-scale-down mb-8 mt-0 mx-auto">
            </div>
            <div class="sign-up-welcome__copy clear-both py-8">
                <p class="text-[22px] sm:text-[24px] mt-0"><em>Throughout the season, you can earn up to $250* in rewards!</em> Be on the lookout for a <em>Yeti<sup>&reg;</sup> LoadOut<sup>&reg;</sup> Bucket</em>, shipping March 2025&mdash;this welcome gift will be delivered to the mailing address provided during sign up.</p>
                <p class="text-[22px] sm:text-[24px]">Throughout the season, be sure to check your email and mobile device for communications from us. They're your roadmap to staying connected and unlocking your rewards. Revisit the <em>Storen Satisfaction Program</em> page at any time for the complete program details.</p>
                <p class="text-[22px] sm:text-[24px] mb-16 md:mb-8"><em>Here are the key dates to look out for:</em></p>
            </div>
        </div>
    </section>

    <section id="program-schedule" class="container mx-auto max-w-screen-xl prose leading-normal">
        <div class="program-schedule__intro">
            <h1 class="header-hex-bar">
                <span class="hidden sm:inline-block">Program Schedule</span>
                <span class="inline-block sm:hidden">Schedule</span>
            </h1>
        </div>
        <div class="program-schedule__details mt-16">
            <table>
                <tr>
                    <td class="text-[26px]">March</td>
                    <td class="text-[22px] sm:text-[24px] leading-snug">Pre-Season Tips &amp; Tricks</td>
                </tr>
                <tr>
                    <td class="text-[26px]">May</td>
                    <td class="text-[22px] sm:text-[24px] leading-snug">Application Check-In</td>
                </tr>
                <tr>
                    <td class="text-[26px]">June</td>
                    <td class="text-[22px] sm:text-[24px] leading-snug">Clean Row Photo &amp; Satisfaction Rating</td>
                </tr>
                <tr>
                    <td class="text-[26px]">July &ndash; August</td>
                    <td class="text-[22px] sm:text-[24px] leading-snug">Invitation to Farm Progress Show &amp; Husker Harvest Days</td>
                </tr>
                <tr>
                    <td class="text-[26px]">September</td>
                    <td class="text-[22px] sm:text-[24px] leading-snug">Refer-a-Friend</td>
                </tr>
                <tr>
                    <td class="text-[26px]">November</td>
                    <td class="text-[22px] sm:text-[24px] leading-snug">Intention Survey &amp; Program Feedback</td>
                </tr>
            </table>
        </div>
    </section>

</main>
